import Dialog from '@material-ui/core/Dialog';
import {Group} from 'packages/common-types/schema-types';
import {DialogProps} from 'packages/common-types/base-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';

type Props = DialogProps &
  Group & {
    onDeleteGroupConfirm: () => Promise<void>;
    loading: boolean;
  };

const ConfirmDeleteGroup = (props: Props) => {
  const {
    groupNumber,
    members,
    modalOpen,
    toggle,
    onDeleteGroupConfirm,
    loading,
  } = props;
  let membersNames;
  if (members) {
    membersNames = members.map((member) => member.fullName).join(',');
  }
  return (
    <Dialog open={modalOpen} onClose={toggle} aria-labelledby="dialog-logout">
      <DialogTitle id="dialog-title">
        ¿Estas seguro de que deseas eliminar un grupo?
      </DialogTitle>
      <DialogContent>
        {loading && <LinearProgress />}
        <DialogContentText>
          Primero asegurate de haber seleccionado el grupo correcto: <br />
          Numero de grupo: {groupNumber + 1} <br />
          Integrantes: {membersNames}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancel
        </Button>
        <Button onClick={onDeleteGroupConfirm} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteGroup;
